import { motion } from "framer-motion";
import { InquiryForm } from "./InquiryForm";
import { useEffect, useState } from "react";
import { isInquirySubmitted } from "../utils";

export const InquiryGate = () => {
  const [submitted, setSubmitted] = useState<boolean>(() =>
    isInquirySubmitted()
  );

  // 🔒 Disable / enable scrolling
  useEffect(() => {
    document.body.style.overflow = submitted ? "" : "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [submitted]);

  if (submitted) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-center justify-center px-4"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md bg-white rounded-xl shadow-2xl p-6"
      >
        <div className="inline-flex items-center gap-2 bg-yellow-100 border-l-4 border-yellow-400 px-4 py-2 rounded shadow-sm mb-4">
          <h2 className="text-xl font-bold text-blue-900">
            Send Us your Query
          </h2>
        </div>

        <p className="text-gray-600 mb-4">
          Please fill the form to continue using the website.
        </p>

        <InquiryForm onSuccess={() => setSubmitted(true)} />
      </motion.div>
    </motion.div>
  );
};
